module.exports = __webpack_public_path__ + "img/member-none-contents.63686027.svg";